import React, { useContext, useState, useRef } from 'react'
import Layout from '../../layout/Layout'
import styles from './ContactUs.module.scss'
import Breadcrumbs from '../../global/Components/Breadcrumb/Breadcrumb'
import { Col, Form, FormGroup, Input, Row, Label, Spinner, Button } from 'reactstrap'
import { postRequest } from '../../global/utils/apiCall'
import { useOnChangeHandler } from '../../global/utils/hooks/useOnChangeHandler'
import { AppContext } from '../../global/globalContext/context'
import SEO from '../../global/Components/SEO/SEO'
import { Toast } from 'primereact/toast';

const CONTACT_US_URL = 'api/v1/contact-us';

export default function ContactUs() {
    const [isLoading, setIsLoading] = useState(false);
    const { setting } = useContext(AppContext);
    const toast = useRef(null);


    const [name, setName, onChangeHandlerName] = useOnChangeHandler('');
    const [email, setEmail, onChangeHandlerEmail] = useOnChangeHandler('');
    const [subject, setSubject, onChangeHandlerSubjet] = useOnChangeHandler('');
    const [contactMessage, seContactMessage, onChangeHandlerContactMessage] = useOnChangeHandler('');

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

    const handleSubmitMessage = async (e) => {
        e.preventDefault();

        setIsLoading(true);

        const formData = new FormData();

        formData.append('name', name);
        formData.append('email', email);
        formData.append('subject', subject);
        formData.append('message', contactMessage);
              
        try {
            const response = await postRequest(CONTACT_US_URL,formData);
            setIsLoading(false);
            showSuccess('Your message has been sent successfully')
        }
        catch (error) {
            setIsLoading(false);
            showError(error?.response?.data?.message)
        }
        finally {
            setIsLoading(false);
        }
    }

  return (
    <>
        <SEO title={'Contact us'} />
        <Toast ref={toast} position="top-center" />

        <Layout>
            <div className={`${styles.pageCover}`}>
                <div className={`${styles.lgtOverlay}`}></div>
                <div className={`container-xxl`}>
                    <div className={`${styles.pageContent} ${styles.pageContentMin} position-relative py-4 d-flex align-items-center`}>
                        <h2 className='text-white fw-bold'>
                            <span className='text-primary'>
                                Contact{' '}
                            </span>
                            us
                        </h2>
                    </div>

                </div>
            </div>
            <div className={`container-xxl`}>
                <div className={`p-2 p-sm-4`} >
                    <Row>
                        <Col>
                            <Breadcrumbs />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} md={5} className='mb-3'>
                            <h2 className='mb-3 fw-bold'>
                                We Are Ready to Help
                            </h2>
                            {
                                setting &&
                                    <>
                                        <div className='mb-3'>
                                            {setting.description}
                                        </div>
                                        <div className='mb-3'>
                                            {
                                                setting.email &&
                                                    <div className='mb-3'>
                                                        <i className='bi bi-envelope-at me-1 text-primary'></i>
                                                        <span className={`me-2 fw-bold`}>
                                                            Email:
                                                        </span>
                                                        <a href={`mailto:${setting.email}`} className={`text-decoration-none text-body`} >
                                                            {setting.email}
                                                        </a>
                                                    </div>

                                            }
                                            {
                                                setting.phone &&
                                                    <div className='mb-3'>
                                                        <i className='bi bi-telephone me-1 text-primary'></i>
                                                        <span className={`me-2 fw-bold`}>
                                                            Phone:
                                                        </span>
                                                        <a className={`text-decoration-none text-body`} href={`tel:${setting.phone}`}>
                                                            {setting.phone}
                                                        </a>                                              
                                                    </div>
                                            }
                                            {
                                                setting.address &&
                                                    <div className='mb-3'>
                                                        <i className='bi bi-geo-alt me-1 text-primary'></i>
                                                        <span className='me-2 fw-bold'>
                                                            Address:
                                                        </span>
                                                        <span>
                                                            {setting.address}
                                                        </span>
                                                    </div>
                                            }
                                            {
                                                setting.postal_code &&
                                                    <div className='mb-3'>
                                                    <svg className='bi bi-mailbox-flag me-1 text-primary' xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M10.5 8.5V3.707l.854-.853A.5.5 0 0 0 11.5 2.5v-2A.5.5 0 0 0 11 0H9.5a.5.5 0 0 0-.5.5v8zM5 7c0 .334-.164.264-.415.157C4.42 7.087 4.218 7 4 7s-.42.086-.585.157C3.164 7.264 3 7.334 3 7a1 1 0 0 1 2 0"/>
                                                        <path d="M4 3h4v1H6.646A4 4 0 0 1 8 7v6h7V7a3 3 0 0 0-3-3V3a4 4 0 0 1 4 4v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a4 4 0 0 1 4-4m0 1a3 3 0 0 0-3 3v6h6V7a3 3 0 0 0-3-3"/>
                                                        </svg>
                                                    <span className='me-2 fw-bold'>
                                                            Postal code
                                                    </span>
                                                    <span>
                                                        {setting.postal_code}
                                                    </span>
                                                </div>
                                            }
                                        </div>
                                        <div>
                                            <ul className={`list-unstyled d-flex ${styles.social}`}>
                                                <li className={`me-2`}>
                                                    <a href='https://instagram.com/letgo_or_trade' target='_blank'>
                                                    <i className='bi bi-instagram fs-4'></i>
                                                    </a>
                                                </li>
                                                <li className={`me-2`}>
                                                    <a href='https://t.me/letgo_or_trade' target='_blank'>
                                                    <i className='bi bi-telegram fs-4'></i>
                                                    </a>
                                                </li> 
                                                {/* <li>
                                                    <a href='#'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-twitter-x" viewBox="0 0 16 16">
                                                        <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
                                                    </svg>
                                                    </a>
                                                </li> */}
                                            </ul>
                                        </div>
                                    </>
                            }
                        </Col>
                        <Col sm={12} md={7}>
                            <div className={`bg-white p-4 mb-3 lgtBackground ${styles.pageForm} position-relative`}>
                                <div className={`fw-bold fs-3 text-center`}>
                                    Send a message
                                </div>
                                <Form className={`p-sm-4 p-2`} onSubmit={(e) => handleSubmitMessage(e)} >
                                    <Row>
                                        <Col sm={12} >
                                            <FormGroup floating>
                                                <Input
                                                    id="name"
                                                    name="name"
                                                    placeholder="Full Name"
                                                    type="text"
                                                    required
                                                    value={name}
                                                    onChange={onChangeHandlerName}
                                                />
                                                <Label for="name">
                                                    Name
                                                    <span className='text-danger'>*</span>
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} >
                                            <FormGroup floating>
                                                <Input
                                                    id="email"
                                                    name="email"
                                                    placeholder="Email"
                                                    type="email"
                                                    required
                                                    value={email}
                                                    onChange={onChangeHandlerEmail}
                                                />
                                                <Label for="email">
                                                    Email
                                                    <span className='text-danger'>*</span>
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} >
                                            <FormGroup floating>
                                                <Input
                                                    id="subject"
                                                    name="subject"
                                                    placeholder="Subject"
                                                    type="text"
                                                    required
                                                    value={subject}
                                                    onChange={onChangeHandlerSubjet}
                                                />
                                                <Label for="subject">
                                                    Subject
                                                    <span className='text-danger'>*</span>
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} >
                                            <FormGroup floating>
                                                <Input
                                                    id="message"
                                                    name="message"
                                                    placeholder="Message"
                                                    type="textarea"
                                                    required
                                                    value={contactMessage}
                                                    onChange={onChangeHandlerContactMessage}
                                                />
                                                <Label for="message">
                                                    Message
                                                    <span className='text-danger'>*</span>
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Button 
                                                type='submit'
                                                disabled={isLoading || !name || !email || !subject || !contactMessage ? true : false   }
                                                >
                                            {
                                                isLoading
                                                    ?  <>
                                                            <Spinner size="sm">
                                                                Loading...
                                                            </Spinner>
                                                            <span>
                                                                {' '}Loading
                                                            </span>
                                                        </>
                                                    : <>
                                                        <i className='bi bi-envelope me-2'></i>
                                                        Send message
                                                      </>
                                            }
                                        </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </Layout>
    </>
  )
}
